import React from "react";

//matches {Link Name|Link Address} tokens, e.g. {Maintain PA|https://example.com} or {Contact Us|mailto:test@example.com}
const LINK_PATTERN = /\{([^|{}]+)\|([^{}]+)\}/g;
const ALLOWED_URL_SCHEMES = ["http:", "https:", "mailto:"];

const isAllowedUrl = (url) => {
  try {
    const scheme = url.trim().split(":")[0].toLowerCase() + ":";
    return ALLOWED_URL_SCHEMES.includes(scheme);
  } catch {
    return false;
  }
};

//renders banner text with {Link Name|Link Address} tokens turned into anchor tags (React nodes, not raw HTML)
export function renderBannerMessage(message) {
  if (!message) return null;

  const nodes = [];
  let lastIndex = 0;
  let key = 0;
  let match;

  LINK_PATTERN.lastIndex = 0;
  while ((match = LINK_PATTERN.exec(message)) !== null) {
    const [fullMatch, linkName, linkAddress] = match;

    if (match.index > lastIndex) {
      nodes.push(message.substring(lastIndex, match.index));
    }

    const url = linkAddress.trim();
    const name = linkName.trim();
    if (isAllowedUrl(url)) {
      const isMailto = url.toLowerCase().startsWith("mailto:");
      nodes.push(
        <a
          key={`bannerlink-${key++}`}
          href={url}
          {...(!isMailto ? { target: "_blank", rel: "noopener noreferrer" } : {})}
        >
          {name}
        </a>
      );
    } else {
      //unsupported/unsafe scheme: keep the original text as-is instead of linking it
      nodes.push(fullMatch);
    }

    lastIndex = match.index + fullMatch.length;
  }

  if (lastIndex < message.length) {
    nodes.push(message.substring(lastIndex));
  }

  return nodes;
}
